import React from 'react';

import Card from '../Common/Card';

const VersionCard = ({ loading, versionData }) => {

	const {
		versionSlug,
		name,
		description
	} = versionData || {};

	return (
		<Card
			loading={loading}
			title={name}
			description={description}
			target={versionSlug ? `${versionSlug}/services` : ''}
			targetLabel="View services"
		/>
	);

};

export default VersionCard;